import { makeStyles, shorthands } from '@fluentui/react-components';

export const useInlineContainerStyles = makeStyles({
  root: {
    maxWidth: '400px',
  },
  label: {
    display: 'block',
    marginBottom: '8px',
  },
  searchboxContainer: {
    width: '-webkit-fill-available',
  },
  searchbox: {
    width: '-webkit-fill-available',
    paddingRight: '0px',
  },
  popOverSurface: {
    boxSizing: 'border-box',
    ...shorthands.padding('0'),
  },
});
